module.exports = __webpack_public_path__ + "img/accountSetting.6125959a.svg";